module.exports = __webpack_public_path__ + "img/qingjia.b9d4911f.png";